// extracted by mini-css-extract-plugin
export default {"input":"DiscountInput_input__XE8cb","selectInput":"DiscountInput_selectInput__-NSdW"};